/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Viewer_Fit_To_ScreenInputs */

const en_document_viewer_fit_to_screen = /** @type {(inputs: Document_Viewer_Fit_To_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fit to screen (0)`)
};

const pt_br2_document_viewer_fit_to_screen = /** @type {(inputs: Document_Viewer_Fit_To_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar à tela (0)`)
};

/**
* | output |
* | --- |
* | "Fit to screen (0)" |
*
* @param {Document_Viewer_Fit_To_ScreenInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const document_viewer_fit_to_screen = /** @type {((inputs?: Document_Viewer_Fit_To_ScreenInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Viewer_Fit_To_ScreenInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_viewer_fit_to_screen(inputs)
	return pt_br2_document_viewer_fit_to_screen(inputs)
});